<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M13 10.5V19h-1v-8.5a.5.5 0 0 0-.5-.5H10V9h1.5c.827 0 1.5.673 1.5 1.5ZM12 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 7c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12Zm-1 0c0-6.065-4.935-11-11-11S1 5.935 1 12s4.935 11 11 11 11-4.935 11-11Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"
                class=""></path>
        </g>
    </svg>
</template>
